/**
 * Formats a navigation link name for GA tagging.
 * Produces "primary-secondary" format (e.g. "women-activity").
 * @param parentCategory - The top-level category name (e.g. "Women").
 * @param sectionName - The sub-category or section name (e.g. "Activity").
 * @returns A lowercase, hyphen-separated string suitable for analytics link names.
 */
export function formatLinkName(
  parentCategory: string | undefined,
  sectionName: string | undefined
): string {
  const primary = parentCategory?.toLowerCase().replace(/\s+/g, '-') ?? '';
  const secondary = sectionName?.toLowerCase().replace(/\s+/g, '-') ?? '';

  if (primary && secondary) {
    return `${primary}-${secondary}`;
  }

  return secondary || primary;
}
